<template>
    <div v-if="myErrors.length">
        <small class="form-text text-danger" v-for="(value, index) in myErrors" :key="index">
            {{value}}
        </small>
    </div>
</template>

<script>
export default {
    props: ['errors', 'name'],
    computed: {
        myErrors() {
            if (typeof this.errors === 'undefined') {
                return []
            }
            if (this.name in this.errors) {
                return this.errors[this.name]
            }
            return []
        },
    },
}
</script>
